import ReactGA from "react-ga4";

// 1. Dynamic Device_type Helper
const getDeviceType = (): "mobile" | "desktop" => {
  if (typeof window === "undefined") return "desktop";
  return window.innerWidth <= 768 ? "mobile" : "desktop";
};

export interface FileUploadParams {
  file_name: string;
  file_size: number;
}

export interface ProceedStageParams {
  previous_stage: string;
  next_stage: string;
}
export interface ProceedStageParamsInFailedCase {
  failure_reason: string;
  error_message: string;
}

export interface ReturnMenuParams {
  previous_page: string;
  next_page: string;
}

export interface LoanSubmissionParams {
  loan_amount: number;
  activity_type: string;
  governorate: string;
}

export interface LoanSubmissionParamsFailedCase {
  failure_reason: "server_error" | "validation_failed" | "timeout";
  error_message: string;
}


export const trackEvent = {
  // Step 1: Tap Loan Request 
  tapLoanRequest: () => {
    ReactGA.event("tap_Loan_request", {
      Device_type: getDeviceType(),
    });
  },

  // Step 2 Upload Front ID Image
  idFrontImageUploaded: (fileDetails: FileUploadParams) => {
    ReactGA.event("id_front_image_uploaded", {
      image_type: "front_id",
      file_name: fileDetails.file_name,
      file_size: fileDetails.file_size,
      Device_type: getDeviceType(),
    });
  },

  // Step 3: Upload Back ID Image
  idBackImageUploaded: (fileDetails: FileUploadParams) => {
    ReactGA.event("id_back_image_uploaded", {
      image_type: "back_id",
      file_name: fileDetails.file_name,
      file_size: fileDetails.file_size,
      Device_type: getDeviceType(),
    });
  },

  // Step 4: Agree to Terms and Conditions
  termsAndConditionsAccepted: () => {
    ReactGA.event("terms_and_conditions_accepted", {
      agreement_status: "accepted",
      Device_type: getDeviceType(),
    });
  },

  // Step 5: Proceed to Data Completion Successfully 
  proceedToDataCompletionSuccessfully: (stages: ProceedStageParams) => {
    ReactGA.event("proceed_to_data_completion_successfully", {
      previous_stage: stages.previous_stage,
      next_stage: stages.next_stage,
      Device_type: getDeviceType(),
    });
  },
  // Step 5: Proceed to Data Completion Failed 
  proceedToDataCompletionFaild: (stages: ProceedStageParamsInFailedCase) => {
    ReactGA.event("proceed_to_data_completion_failed", {
      failure_reason: stages.failure_reason,
      error_message: stages.error_message,
      Device_type: getDeviceType(),
    });
  },

  // Step 6: Enter Loan Amount 
  loanAmountEntered: (amount: number) => {
    ReactGA.event("loan_amount_entered", {
      loan_amount: amount,
      Device_type: getDeviceType(),
    });
  },

  // Step 7: Enter Full Name 
  fullNameEntered: (nameLength: number) => {
    ReactGA.event("full_name_entered", {
      full_name_length: nameLength,
      Device_type: getDeviceType(),
    });
  },

  // Step 8: Enter Mobile Number 
  mobileNumberEntered: (prefix: string) => {
    ReactGA.event("mobile_number_entered", {
      mobile_number_prefix: prefix,
      Device_type: getDeviceType(),
    });
  },

  // Step 9: Select Activity Type 
  activityTypeSelected: (activityType: string) => {
    ReactGA.event("activity_type_selected", {
      activity_type: activityType,
      Device_type: getDeviceType(),
    });
  },

  // Step 10: Select Activity Address 
  activityAddressSelected: (governorate: string) => {
    ReactGA.event("activity_address_selected", {
      Governorate: governorate,
      Device_type: getDeviceType(),
    });
  },

  // Step 11: Submit Loan Request case(success) 
  loanRequestSubmittedSuccess: (details: LoanSubmissionParams) => {
    ReactGA.event("loan_request_submitted_success", {
      loan_amount: details.loan_amount,
      activity_type: details.activity_type,
      governorate: details.governorate,
      Device_type: getDeviceType(),
    });
  },

  // Step 11: Submit Loan Request case(failed) 
  loanRequestSubmittedFailed: (details: LoanSubmissionParamsFailedCase) => {
    ReactGA.event("loan_request_submitted_failed", {
      failure_reason: details.failure_reason,
      error_message: details.error_message,
      Device_type: getDeviceType(),
    });
  },

  // Step 12: Return to Main Menu 
  returnToMainMenu: (pages: ReturnMenuParams) => {
    ReactGA.event("return_to_main_menu", {
      previous_page: pages.previous_page,
      next_page: pages.next_page,
      Device_type: getDeviceType(),
    });
  },
};